<section class="emi-section pt-5 pb-5" id="emiCalculator">
    <div class="">
        <h2 class="page-sub-title cv-text-dark mb-4">EMI Calculator</h2>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 order-2 order-md-1">
                <div class="calculator-area">
                    <div class="slider">
                        <div class="d-flex align-items-center loan-amount">Loan Amount
                          <span id="loanValue" class="mb-0 ms-auto" style="max-width: 95px;">
                          <input
                          class ="form-control form-control-sm" [(ngModel)]="productPrice"
                          oninput="javascript: if (this.value?.length > 8) this.value = this.value.slice(0, 8);"
                          type="number" [maxLength]="8" (keyup)="valueChange(productPrice,$event)"
                          [ngModelOptions]="{standalone: true}">
                        </span>
                          </div>
                          <input type="range" class="e-range" [(ngModel)]="loan" min="0" max="10000000" value="loan"

                                (change)="valueChange(loan,$event)">
                        <div class="d-flex align-items-center total-amount">0<span class="ms-auto">10000000</span>
                        </div>
                    </div>
                    <div class="slider">
                      <div class="d-flex align-items-center loan-amount">Down Payment
                        <span id="downPaymentValue" class="mb-0 ms-auto" style="max-width: 95px;">
                          <input class ="form-control form-control-sm"
                           [(ngModel)]="downPaymentPrice"
                        oninput="javascript: if (this.value?.length > 8) this.value = this.value.slice(0, 8);"
                        type="number" [maxLength]="8" (keyup)="valueChangeDownPayment(downPaymentPrice,$event)"
                        [ngModelOptions]="{standalone: true}">
                        </span>
                        </div>
                        <input type="range" class="e-range" [(ngModel)]="downPayment" min="0" [max]="productPrice" value="downPayment"

                              (change)="valueChangeDownPayment(downPayment,$event)">
                      <div class="d-flex align-items-center total-amount">0<span class="ms-auto">{{productPrice}}</span>
                      </div>
                  </div>
                    <div class="slider">
                        <div class="d-flex align-items-center loan-amount">Duration of Loan
                          <span id="loanValue" class="mb-0 ms-auto" style="max-width: 95px;">
                            <input class ="form-control  form-control-sm"
                            [(ngModel)]="userYear"
                            oninput="javascript: if (this.value?.length > 2) this.value = this.value.slice(0, 2);"
                            type="number" placeholder="Yr" [maxLength]="2" (keyup)="valueChangeYear(userYear,$event)"
                            [ngModelOptions]="{standalone: true}">
                            </span>
                          </div>
                            <input [(ngModel)]="temi.value" class="e-range" type="range" min="1" max="10" value="" step="1"
                            (change)="calculateEmi()">
                        <div class="d-flex align-items-center total-amount">1 Year<span class="ms-auto">{{userYear}} Years</span>
                        </div>
                    </div>
                    <div class="slider mb-0">
                      <div class="d-flex align-items-center loan-amount">Rate of interest
                        <span id="loanValue" class="mb-0 ms-auto" style="max-width: 95px;">
                          <input class ="form-control form-control-sm"
                         [(ngModel)]="userInterest"
                        oninput="javascript: if (this.value?.length > 5) this.value = this.value.slice(0, 5);"
                        type="number" [maxLength]="5"  (keyup)="valueChangeInterest(userInterest,$event)" (blur)="intersetchange(userInterest,$event)"
                        [ngModelOptions]="{standalone: true}">
                        </span>
                      </div>
                  </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 order-1 order-md-2 mb-3 mb-md-0">
                <div class="graph-area">
                    <div class="monthly-emi">
                        <div class="row">
                            <div class="col-6 text-start">
                                <div class="emi-text">Monthly EMI</div>
                                <div class="emi-amount">₹ {{ result.emi }}</div>
                            </div>
                            <div class="col-6 text-end">
                                <div class="emi-text text-nowrap">Total Amt Payable</div>
                                <div class="emi-amount-payable">₹ {{ result.total }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center amount-highchart">
                        <highcharts-chart  [Highcharts]="Highcharts" [options]="chartOptions"

                        ></highcharts-chart>
                    </div>
                    <div class="chart-legend-amount">
                        <div class="row g-0">
                            <div class="col-6 col-md-7 col-lg-6 ">
                                <div class="text">
                                    <span style="background-color: #ADCCF3;"></span> Principal amount
                                </div>
                                <div class="text">
                                    <span style="background-color: #307FE2;"></span> Interest amount
                                </div>
                            </div>
                            <div class="col-6 col-md-5 col-lg-6 text-end">
                                <div class="amount">
                                  ₹ {{convertToIndianFormat(newProductPrice.toFixed(0)) }}
                                </div>
                                <div class="amount">
                                  ₹ {{ result.interest }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
